
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"affected-views-flyout.header":"Affected views","affected-views-flyout.header.diverging-filters":"Views with different filter assignment","affected-views-flyout.no-content":"Does not affect any view of this worksheet"},"de":{"affected-views-flyout.header":"Betroffene Sichten","affected-views-flyout.header.diverging-filters":"Sichten mit abweichender Filterbelegung","affected-views-flyout.no-content":"Betrifft keine Sicht dieses Arbeitsblatts"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();